import { UtilService } from 'common/services/utilService'

import {
  isSchedulePreferenceUserId,
  readSchedulePreferences,
  updateSchedulePreferences,
  type ScheduleCalendarView,
} from './schedulePreferencesStorage'

const LEGACY_VIEW_KEY = 'currentView'

const parseView = (value: unknown): ScheduleCalendarView | null =>
  value === 'day' || value === 'week' ? value : null

const readLegacyView = (): ScheduleCalendarView | null => {
  try {
    const raw = window.localStorage.getItem(LEGACY_VIEW_KEY)
    if (!raw) return null
    return parseView(UtilService.safeParseJSON<unknown>(raw, raw))
  } catch {
    return null
  }
}

const removeLegacyView = (): void => {
  try {
    window.localStorage.removeItem(LEGACY_VIEW_KEY)
  } catch {
    // Storage can be unavailable; the in-memory view still applies.
  }
}

export const getScheduleView = (userId: number | null | undefined): ScheduleCalendarView => {
  if (!isSchedulePreferenceUserId(userId)) return 'day'
  const stored = parseView(readSchedulePreferences()[String(userId)]?.view)
  if (stored) {
    removeLegacyView()
    return stored
  }

  const legacy = readLegacyView()
  if (!legacy) return 'day'
  return setScheduleView(userId, legacy)
}

export const setScheduleView = (
  userId: number | null | undefined,
  view: ScheduleCalendarView,
): ScheduleCalendarView => {
  const next = parseView(view) ?? 'day'
  if (!isSchedulePreferenceUserId(userId)) return next
  updateSchedulePreferences(userId, (current) => ({ ...current, view: next }))
  removeLegacyView()
  return next
}
